import { useEffect, useState } from 'react';
import { Input, Space, Table, DatePicker, Select } from 'antd';
import { useDispatch } from 'react-redux';
import debounce from 'lodash.debounce';

const { RangePicker } = DatePicker;

function TableComponent({listData, columns, placeholder, roleType, reload, searchedData, onRow, searchData, listName = null, selectPlaceHolder}) {
    const dispatch = useDispatch();
    const [data, setData] = useState();
    const [total, setTotal] = useState(0);
    const [startDate, setStartDate] = useState();
    const [selectedUser, setSelectedUser] = useState(null)
    const [endDate, setEndDate] = useState();
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
    });
    const [isLoading, setIsLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState("desc");

    useEffect(() => {
        getData(pagination.current, pagination.pageSize, search)
    }, [pagination, search, reload, selectedUser, sortField, sortOrder]);

    const getData = async (page = 1, limit = 10, search = '') => {
        let data = {
            ...searchData,
            page: page,
            limit,
            sortField,
            sortOrder
        };
        if (roleType) {
            data = {
                ...data,
                roleType
            }
        }
        if (listName == "Job" || listName == "User" || listName == "attendance") {
            data = {
                ...data,
                startDate: startDate,
                endDate: endDate,
            }
        }
        if (listName == "User") {
            data = {
                ...data,
                selectedUser
            }
        }

        if (search.trim() !== "") {
            data = {
                ...data,
                search
            }
        }
        setIsLoading(true)

        const result = await dispatch(listData(data));

        if (listData.fulfilled.match(result)) {
            const response = result?.payload;
            setData(response?.data || []);
            setTotal(response?.total);
            setIsLoading(false)
            if (typeof searchedData == "function") {
                searchedData(response?.data)
            }
        } else {
            setIsLoading(false)
            console.error("Failed to fetch data");
        }
    };

    // const handleTableChange = (paginationInfo, filters, sorter, extra) => {
    //     setPagination({
    //       current: paginationInfo.current,
    //       pageSize: paginationInfo.pageSize,
    //     });
    //     if (!sorter?.field) {
    //         setSortField("createdAt");
    //         let updatedSort = sortOrder == "desc" ? "asc" : "desc";
    //         setSortOrder(updatedSort);
    //         return;
    //     }
    //     if (sorter?.field && sorter?.order) {
    //         setSortField(sorter.field);
    //         setSortOrder(
    //             sorter.order === "ascend" ? "asc" : "desc"
    //         );
    //     }
    // };

    const handleTableChange = (paginationInfo, filters, sorter) => {
        setPagination({
            current: paginationInfo.current,
            pageSize: paginationInfo.pageSize,
        });

        if (sorter) {
            setSortField(sorter?.field || "createdAt");
            setSortOrder(
                sorter?.order === "ascend" ? "asc" : "desc"
            );
            console.log(sortOrder, sortField, sorter)
        }
    };

    const handleSearch = debounce((value) => {
        setPagination((prev) => ({ ...prev, current: 1 }));
        setSearch(value);
    }, 500);

    const handleDateChange = (dates, dateStrings) => {
        setPagination((prev) => ({ ...prev, current: 1 }));
        setStartDate(dateStrings[0]);
        setEndDate(dateStrings[1]);
    }

    const handleUserChange = (value) => {
        setSelectedUser(value);
    }

    const providerOptions = data?.map((data) => ({
        label: `${data.first_name || ''} ${data.last_name || ''}`.trim() || data.email,
        value: data._id || data.key
    })) || [];

    return (
        <>
            <Space style={{ marginBottom: 16 }}>
                {listName != "attendance" && placeholder ? (
                    <Input.Search
                        placeholder={placeholder}
                        onChange={(e) => handleSearch(e.target.value)}
                        allowClear
                        style={{ width: 300 }}
                    />
                ) : "" }
            {listName == "Job" || listName == "User" || listName == "attendance" ? (
                <RangePicker onChange={handleDateChange}/>
            ) : ""}
            {listName == "User" ? (
                <Select
                    placeholder={selectPlaceHolder}
                    allowClear
                    style={{ width: 200 }}
                    onChange={handleUserChange}
                    value={selectedUser}
                    options={providerOptions}
                />
            ) : ""}
            </Space>
            <Table dataSource={data} columns={columns}
                loading={isLoading}
                rowKey={(record) => record._id}
                pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total,
                    showSizeChanger: true,
                    showTotal: (total) => `Total ${total} items`,
                }}
                onChange={handleTableChange}
                onRow={onRow}
            />
        </>
    );
}

export default TableComponent;